function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__b",
  x1: "56.236%",
  x2: "32.65%",
  y1: "30.195%",
  y2: "99.191%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#279DE1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7CE9C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__d",
  x1: "55.776%",
  x2: "33.93%",
  y1: "30.195%",
  y2: "99.191%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#279DE1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7CE9C4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__e",
  x1: "67.689%",
  x2: ".784%",
  y1: "30.195%",
  y2: "99.191%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#279DE1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#7CE9C4"
})), /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M4.191 4.853c2.315 0 4.191 1.975 4.191 4.412v4.853H0V9.265c0-2.437 1.876-4.412 4.191-4.412zm0-4.853c1.097 0 1.985.889 1.985 1.985 0 1.097-.888 1.986-1.985 1.986-1.096 0-1.985-.89-1.985-1.986S3.095 0 4.19 0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(3.088 .441)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#prefix__b)",
  xlinkHref: "#prefix__a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#prefix__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__d)",
  d: "M8.382 14.118V9.265c0-2.437-1.876-4.412-4.19-4.412-.227 0-.887.128-1.104.164v9.1h5.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0D6AB7",
  d: "M5.001 11.464c-1.869-2.54-1.693-5.473-1.403-6.567C1.564 5.2 0 7.04 0 9.265v4.853h8.099c-1.34-.715-2.372-1.6-3.098-2.654z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#164A7D",
  d: "M3.42 6.618c0-.439.11-1.347.185-1.722-1.128.166-2.11.804-2.765 1.718.12.004 2.038.007 2.58.004z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.191,
  cy: 1.985,
  r: 1.985,
  fill: "url(#prefix__e)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#164A7D",
  d: "M5.797.818C5.436.322 4.85 0 4.19 0 3.095 0 2.206.889 2.206 1.985c0 .986.719 1.804 1.66 1.96.135-.312.7-1.96 1.93-3.127z"
})));

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.7adaaa9e.svg";
export { ForwardRef as ReactComponent };